import * as Sentry from "@sentry/react";
import { VITE_SENTRY_DNS, VITE_SENTRY_ENVIRONMENT } from "./constants/config";

Sentry.init({
  dsn: VITE_SENTRY_DNS,
  environment: VITE_SENTRY_ENVIRONMENT ? VITE_SENTRY_ENVIRONMENT : "local",
});
